var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcEditGray(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.23166 11.3867C2.87583 11.3867 2.54333 11.2642 2.30416 11.0367C2.00083 10.7509 1.85499 10.3192 1.90749 9.85257L2.12333 7.96257C2.16416 7.60674 2.37999 7.13424 2.63083 6.87757L7.41999 1.8084C8.61583 0.542569 9.86416 0.507569 11.13 1.7034C12.3958 2.89924 12.4308 4.14757 11.235 5.4134L6.44583 10.4826C6.20083 10.7451 5.74583 10.9901 5.38999 11.0484L3.51166 11.3692C3.41249 11.3751 3.32499 11.3867 3.23166 11.3867ZM9.29249 1.69757C8.84333 1.69757 8.45249 1.97757 8.05583 2.39757L3.26666 7.47257C3.14999 7.59507 3.01583 7.88674 2.99249 8.0559L2.77666 9.9459C2.75333 10.1384 2.79999 10.2959 2.90499 10.3951C3.00999 10.4942 3.16749 10.5292 3.35999 10.5001L5.23833 10.1792C5.40749 10.1501 5.68749 9.9984 5.80416 9.8759L10.5933 4.80674C11.3167 4.03674 11.5792 3.32507 10.5233 2.3334C10.0567 1.88424 9.65416 1.69757 9.29249 1.69757Z",
    fill: "#3D3962"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1151 6.38782C10.1034 6.38782 10.0859 6.38782 10.0743 6.38782C8.25426 6.20699 6.79009 4.82449 6.51009 3.01615C6.47509 2.77699 6.63842 2.55532 6.87759 2.51449C7.11676 2.47949 7.33842 2.64282 7.37926 2.88199C7.60092 4.29365 8.74426 5.37865 10.1676 5.51865C10.4068 5.54199 10.5818 5.75782 10.5584 5.99699C10.5293 6.21865 10.3368 6.38782 10.1151 6.38782Z",
    fill: "#3D3962"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.25 13.2705H1.75C1.51083 13.2705 1.3125 13.0722 1.3125 12.833C1.3125 12.5938 1.51083 12.3955 1.75 12.3955H12.25C12.4892 12.3955 12.6875 12.5938 12.6875 12.833C12.6875 13.0722 12.4892 13.2705 12.25 13.2705Z",
    fill: "#3D3962"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcEditGray);
export default __webpack_public_path__ + "static/media/ic_edit_gray.a314dbc5a43a1e64fada4858ef837a69.svg";
export { ForwardRef as ReactComponent };